import React, { FC } from 'react'
import { LanguageSelect, LocaleCodes } from '../../../../constants/localization.constants'
import Typography from '../../typography'
import { FooterTopHat, LanguageSelector } from '../style'
import { Caret_Logo, Globe_Logo, UIPath_Logo, UIPath_Logo_TM } from '../utils/footerLogos'

type Props = {
  localePage: string
  langCode: string
  topHatLinks: any
  languageSelector: any
  language: any
}

const getLangTitle = (title: string) => {
  switch (title) {
    case 'Spanish':
      return 'Español'

    case 'Portuguese':
      return 'Português'

    default:
      return title
  }
}

const TopHatLinks: FC<Props> = ({
  localePage,
  langCode,
  topHatLinks,
  languageSelector,
  language,
}) => {
  const handleLanguageSelectorClick = (e: any) => {
    e.target.classList.toggle('LanguageSelector--Active')
  }

  return (
    <FooterTopHat>
      <a href={localePage} className="Footer__UIPathLogo">
        {langCode === LocaleCodes.CHINESE.code ? UIPath_Logo_TM : UIPath_Logo}
      </a>

      {topHatLinks?.length && (
        <div>
          {topHatLinks.map((item: any, index: number) => {
            let imgSrc = item?.icon?.image?.file?.url
            let imgAlt = item?.icon?.altText

            return (
              <a key={index} href={item.url} className="Footer__TopHatLink Footer__Text--Bold">
                {imgSrc && (
                  <div>
                    <img src={imgSrc} alt={imgAlt} />
                  </div>
                )}
                {item.ctaText}
              </a>
            )
          })}
        </div>
      )}

      <LanguageSelector
        ref={languageSelector}
        className="Footer__LanguageSelector"
        onClick={handleLanguageSelectorClick}>
        {Globe_Logo}
        <Typography className="LanguageSelector__CurrentLocale font__inter" type="bodyXS">
          {language}
        </Typography>
        {Caret_Logo}

        <ul>
          {LanguageSelect.rows.map((lang: any, index: number) => {
            const className =
              lang.title === language ? { className: 'LanguageSelector__Locale--Active' } : {}
            const langTitle = getLangTitle(lang.title)
            if (lang.title === 'Taiwan') return null

            return (
              <li key={index} {...className}>
                <a href={lang.href}>
                  <Typography type="bodyXS" className="font__inter">
                    {langTitle}
                  </Typography>
                </a>
              </li>
            )
          })}
        </ul>
      </LanguageSelector>
    </FooterTopHat>
  )
}

export default TopHatLinks
